/*
 * Light YouTube Embeds by @labnol
 * Credit: https://www.labnol.org/
 */

function labnolIframe(div) {
  var iframe = document.createElement("iframe")
  iframe.setAttribute(
    "src",
    "https://www.youtube.com/embed/" +
      div.dataset.id +
      `?autoplay=1&start=${div.dataset.videostart}`
  )
  iframe.setAttribute("frameborder", "0")
  iframe.setAttribute("allowfullscreen", "1")
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  )
  div.parentNode.replaceChild(iframe, div)
}

function initYouTubeVideos() {
  var playerElements = document.querySelectorAll(".youtube-player")

  for (var n = 0; n < playerElements.length; n++) {
    var videoId = playerElements[n].dataset.id
    var videoStartPosition = playerElements[n].dataset.videostart || "0"
    var thumbnailQuality =
      playerElements[n].dataset.thumbnailQuality || "maxresdefault"
    var div = document.createElement("div")
    div.setAttribute("data-id", videoId)
    div.setAttribute("data-videostart", videoStartPosition)
    var thumbNode = document.createElement("img")
    thumbNode.src = "//i.ytimg.com/vi/ID/THUMBNAILRESOLUTION.jpg".replace(
      "ID",
      videoId
    )
    thumbNode.src = thumbNode.src.replace(
      "THUMBNAILRESOLUTION",
      thumbnailQuality
    )
    div.appendChild(thumbNode)
    var playButton = document.createElement("div")
    playButton.setAttribute("class", "play")
    div.appendChild(playButton)
    div.onclick = function () {
      labnolIframe(this)
    }
    playerElements[n].appendChild(div)
  }
}

document.addEventListener("DOMContentLoaded", initYouTubeVideos)
